<template lang="pug">
el-dialog(:title="editingMember && editingMember.id ? '编辑成员' : '创建成员'", :visible="memberFormVisible" :before-close="hideMemberForm")
    template(v-if="editingMember")
        el-form(:model="form" ref="form")
            el-form-item(label="账号" prop="name" label-width="80px")
                el-input(v-model="form.name" :disabled="true")
            el-form-item(label="展示名" prop="displayName" label-width="80px")
                el-input(v-model="form.displayName")
            el-form-item(label="组织角色" prop="orgRole" label-width="80px")
                el-select(v-model="form.orgRole")
                    el-option(v-for="item in orgRoleOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled")
            el-form-item(label="邮箱" prop="email" label-width="80px")
                el-input(v-model="form.email")
            el-form-item(label="手机号码" prop="phoneNumber" label-width="80px")
                el-input(v-model="form.phoneNumber")
            el-form-item(label="描述" prop="description" label-width="80px")
                el-input(type="textarea" v-model="form.description")
    template(v-else)
        el-form(:model="form" :rules="addRules" ref="form")
            el-form-item(label="账号" prop="name" label-width="80px")
                el-input(v-model="form.name")
                    template(slot="append") @{{ orgname }}.vsatdata
            el-form-item(label="密码" prop="password" label-width="80px")
                el-input(type="password" v-model="form.password")
            el-form-item(label="确认密码" prop="confirmPass" label-width="80px")
                el-input(type="password" v-model="form.confirmPass")
            el-form-item(label="组织角色" prop="orgRole" label-width="80px")
                el-select(v-model="form.orgRole")
                    el-option(v-for="item in orgRoleOptions" :key="item.value" :label="item.label" :value="item.value"  :disabled="item.disabled")
    .dialog-footer(slot="footer")
        el-button(@click="hideMemberForm") 取 消
        el-button(type="primary", @click="submit", :loading="loading") 确 定
</template>

<script>
// @ is an alias to /src
import { addOrgMemberAPI, updateOrgMemberAPI } from '@/services'
const defaultForm = {
  name: '',
  password: '',
  confirmPass: '',
  displayName: null,
  phoneNumber: null,
  email: null,
  orgRole: 'member'
}
export default {
  name: 'MemberForm',
  props: ['memberFormVisible', 'editingMember', 'orgname'],
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!/^(\w+)$/.test(value)) {
        callback(
          new Error('用户名只能包含大小写英文字母、数字和下划线')
        )
      } else if (value.length < 3) {
        callback(new Error('用户名字符不得少于3个'))
      } else {
        callback()
      }
    }
    const validatePassSecure = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.confirmPass !== '') {
          this.$refs.form.validateField('confirmPass')
        }
        callback()
      }
    }
    const validatePassConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      membership: {},
      form: Object.assign({}, defaultForm),
      addRules: {
        name: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          },
          {
            required: true,
            validator: validateUsername,
            trigger: 'change'
          }
        ],
        password: [
          {
            min: 8,
            max: 64,
            message: '密码长度不得小于8',
            trigger: 'blur'
          },
          {
            required: true,
            validator: validatePassSecure,
            trigger: 'blur'
          }
        ],
        confirmPass: [
          {
            required: true,
            validator: validatePassConfirm,
            trigger: 'change'
          }
        ]
      },
      orgRoleOptions: [
        {
          value: 'owner',
          label: '组织所有人',
          disabled: true
        },
        {
          value: 'admin',
          label: '组织管理员',
          disabled: false
        },
        {
          value: 'member',
          label: '组织成员',
          disabled: false
        }
      ]
    }
  },
  methods: {
    /**
         * Backend Service API Func Wrapper
         */
    async addOrgMember() {
      this.loading = true
      try {
        const res = await addOrgMemberAPI(
          this.orgname,
          this._.pickBy(this.form, this._.identity)
        )
        if (res.status === 201) {
          this.$message.success('保存成功')
        }
      } catch (err) {
        this.$message.error(err.data.description)
      } finally {
        this.loading = false
      }
    },
    async updateOrgMember() {
      this.loading = true
      try {
        const res = await updateOrgMemberAPI(
          this.orgname,
          this.editingMember.name,
          this._.pickBy(this.form, this._.identity)
        )
        if (res.status === 200) {
          this.$message.success('保存成功')
        }
      } catch (err) {
        this.$message.error(err.data.description)
      }
      this.loading = false
    },
    /**
         * UI Control
         */
    hideMemberForm() {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('hideMemberForm')
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }
        if (this.memberFormVisible && this.editingMember) {
          this.updateOrgMember()
        } else {
          this.addOrgMember()
        }
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$emit('refreshMembers')
        this.form = Object.assign({}, defaultForm)
        this.hideMemberForm()
      })
    }
  },
  watch: {
    memberFormVisible(val) {
      if (val && this.editingMember) {
        this.form = Object.assign({}, defaultForm, this.editingMember)
      } else if (val && !this.editingMember) {
        this.form = Object.assign({}, defaultForm)
      }
    }
  },
  mounted() {}
}
</script>
<style lang="stylus" scoped>
.el-select {
  width: 100%;
}
</style>
